export const navigation = {
	header: {
		title: "Todas as categorias",
		searchTooltip: "Buscar categorias",
		addCategoryTooltip: "Adicionar categoria",
		showZeroProductCategoriesTooltip: "Mostrar categorias sem produtos",
		hideZeroProductCategoriesTooltip: "Ocultar categorias sem produtos",
		showEmptyCategories: "Mostrar categorias sem produtos",
		hideEmptyCategories: "Ocultar categorias sem produtos",
		show: "Mostrar",
		hide: "Ocultar",
	},
	search: {
		placeholder: "Buscar categoria",
		closeTooltip: "Fechar busca",
	},
	subcategories: {
		levelPrefix: "Nível",
	},
	priorityLabel: "Nível",
	categoryDisabledTooltip: "Não é possível adicionar produtos a essa categoria",
	loadingCategories: "Carregando categorias",
	emptyState: {
		noSearchResults: {
			title: "Nenhuma categoria encontrada",
			message: "Não encontramos categorias que correspondam à sua busca por",
		},
		noCategories: {
			title: "Nenhuma categoria encontrada",
			message:
				"Você ainda não possui categorias de produtos. Crie sua primeira categoria para organizar seus produtos.",
		},
		noCategoriesWithFilters: {
			title: "As categorias estão ocultas",
			message:
				"Não existem categorias que correspondam ao seus filtros atuais. Clique para mostrar todas as categorias ou remova os filtros.",
		},
		clearSearchButton: "Limpar busca",
		createCategoryButton: "Criar categoria",
		showHiddenCategoriesButton: "Mostrar categorias",
	},
};
